import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthStateService } from '../services/auth-state.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // Anonymous endpoints that must NOT carry an Authorization header. Adding a
  // bearer token to these causes the backend to bind the cart/session to the
  // authenticated user instead of the cookie-bound anonymous session, or to
  // reject tokenized public links such as RSVP email links.
  private static readonly ANONYMOUS_PATH_PATTERNS: RegExp[] = [
    /\/ecommerce\/opn\/v1\/sessions\//,
    /\/ecommerce\/opn\/v1\/session\//,
    /\/ecommerce\/opn\/v1\/cart\//,
    /\/ecommerce\/opn\/v1\/cart-items\//,
    /\/eticketing\/opn\/v1\/rsvp\//,
  ];

  constructor(private readonly _authStateService: AuthStateService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isAnonymousEndpoint(request.url)) {
      return next.handle(request);
    }

    const token = this._authStateService.getToken();

    if (token) {
      const clonedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }

  private isAnonymousEndpoint(url: string): boolean {
    return AuthInterceptor.ANONYMOUS_PATH_PATTERNS.some((pattern) =>
      pattern.test(url)
    );
  }
}
